import { findCurrentComponentPathInLayoutByRectId, findAllRects } from "utils"
// 获取当前父容器的引擎数据
class DataLinkage {
  constructor(vue) {
    this.context = vue
    this.targetCompoennetRectId = null
    this.targetCompoennetAppId = null
  }

  init() {
    this.initMultiFilterData()
  }

  // 初始化多级筛选组件
  initMultiFilterData() {
    const self = this
    const rectAttr = self.context.options
    if (!rectAttr) return
    let ids = {
      container_id: self.context.myid.container_id,
      rect_id: self.context.myid.rect_id
    }
    self.findLayoutComponent(self.context.myid.rect_id)

    let data = self.context.shareDataPool.data
    Object.defineProperty(data, `layout-data-type-${self.targetCompoennetAppId}`, {
      enumerable: true,
      configurable: true,
      get: function () {
        console.log("get属性方法,当前对象：", self)
      },
      set: function (newValue) {
        let targetData = []
        const generalDataTypes = JSON.parse(newValue).data.data.generalDataTypes
        self.doObj(generalDataTypes, targetData)
        //获取选中样式
        let multiFilterOptions = self.context.$store.state[self.context.request_prefix].page.children[0].children.find(
          rect => rect.rect_id === self.context.myid.rect_id
        ).options
        let ifMore = multiFilterOptions.moreFilter
        let model = multiFilterOptions.model
        if (ifMore) {
          console.log("targetData", targetData)
          let allList = {
            active: true,
            children: [],
            label: "全部",
            publicId: "",
            relId: ""
          }
          targetData.forEach((item, index) => {
            item.children.unshift(allList)
          })
        } else {
          if (targetData.length > 0) {
            targetData[0].active = true
          }
        }
        self.context.$changeOptionsEV(
          targetData,
          model === "tree" ? "filterOptions" : "selectOptions",
          false,
          null,
          ids,
          true
        )
      }
    })
    self.initMultiFilterWatcher(self.context.myid.rect_id)
  }

  doObj(datas, targetData) {
    for (let key in datas) {
      targetData.push({
        id: datas[key].publicId,
        label: datas[key].name,
        value: datas[key].url,
        iconUrl: datas[key].iconUrl,
        publicId: datas[key].publicId,
        relId: datas[key].relId,
        children: [],
        cid: datas[key].id,
        pid: datas[key].pid,
      })
      if (typeof datas[key].subGeneralDataTypes == "object") {
        this.doObj(datas[key].subGeneralDataTypes, targetData[key].children)
      }
    }
  }

  // 找到当前通栏中的图文组件
  findLayoutComponent(rect_id) {
    const layout = this.context.$store.state[this.context.request_prefix].page.pageLayoutList
    const pageLayout = findCurrentComponentPathInLayoutByRectId(layout, rect_id)[0]
    // 找到当前通栏下的所有组件id
    const rectIds = findAllRects(layout[pageLayout])
    // 需要过滤掉rect_id
    rectIds.splice(rectIds.indexOf(rect_id), 1)
    // 找到rectIds中的图文组件
    this.context.$store.state[this.context.request_prefix].page.children[0].children.forEach(item => {
      if (rectIds.includes(item.rect_id) && item.shape === "emptyLayoutComponent" && item.options.appId) {
        this.targetCompoennetRectId = item.rect_id
        this.targetCompoennetAppId = item.options.appId
      }
    })
  }

  initMultiFilterWatcher(rectId) {
    const self = this
    this.context.$watch(
      function () {
        return self.context.$store.state[self.context.request_prefix].page.children[0].children.find(
          rect => rect.rect_id === rectId
        ).options.selectOptions
      },
      async function (newVal, oldVal) {
        let typeIdsArr = [],
          relIdsArr = [],
          isOr = false,
          groupTypeId = {}
        if (newVal.length) {
          if (self.context.model === "tree") {
            newVal = [...newVal].reverse().filter(item => item.id)
            ;(typeIdsArr = [newVal[0]?.publicId || ""]), (relIdsArr = [newVal[0]?.relId || ""])
          } else {
            let flag = false
            newVal.forEach(item => {
              if (item.active) {
                typeIdsArr.push(item.publicId)
                relIdsArr.push(item.relId)
              }
              if (item.children.length) {
                item.children.forEach(item1 => {
                  if (item1.active) {
                    typeIdsArr.push(item1.publicId)
                    relIdsArr.push(item1.relId)
                    // 廖欢让加上groupTypeId 多级筛选选择多个时取交集
                    if (item1.label !== "全部") {
                      flag = true
                    }
                    // 后端说pid等于0时不传
                    item1.pid !== "0" ? groupTypeId[item1.pid] ? groupTypeId[item1.pid] = groupTypeId[item1.pid] + ',' + item1.cid : groupTypeId[item1.pid] = item1.cid : groupTypeId = ""
                  }
                })
              }
            })
            if (flag && typeIdsArr.length > 1) {// 多个分类
              isOr = true
            }
          }     
        }
        // 需要根据当前多级筛选选中的节点类型，决定显示内容
        // 通知列表更新数据
        self.context.$eventBus.$emit(
          `update-layout-data-eventBus-${self.context.myid.container_id}-${self.targetCompoennetRectId}`,
          {
            typeIds: typeIdsArr,
            relIds: relIdsArr,
            isOr: isOr,
            groupTypeId: isOr ? groupTypeId : ""
          }
        )
      },
      {
        immediate: true
      }
    )
  }
}
export default {
  methods: {
    dataLinkagePlugin() {
      new DataLinkage(this).init()
    }
  }
}
